import * as React from 'react';
import { RouteComponentProps } from 'react-router';

import NotFoundPage from './NotFound';

interface INotFoundProps extends RouteComponentProps<{ 
    eshop: string;
}> {
}

class NotFound extends React.Component<INotFoundProps> {

    render() {
        return (
            <div>
                <NotFoundPage
                    domain={this.props.match.params.eshop}
                />
            </div>
        );
    }
}


export default NotFound;



// WEBPACK FOOTER //
// ./src/scenes/NotFound/index.tsx